import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import "../components/Blog.css";

const BlogDetails = () => {

  const location = useLocation();

  const [otherblogs, setOtherBlogs] = useState([]);

  // Fetch Blogs
  const fetchBlogs = async () => {
    try {
      const res = await fetch("reactapi/api/codeinputs/get_otherblogs", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ url: location.pathname }),
      });
      const data = await res.json();
      setOtherBlogs(data.html || []);
      console.log(otherblogs.length);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchBlogs();
  }, []);

  return (
    <>
      {/* BLOG HERO */}
      <section className="blog-hero">
        <div className="container">
          <div className="row justify-content-center text-center">
            <div className="col-lg-8">
              <h1>
                Top Notepad++ Plugins to Boost Productivity and Efficiency
              </h1>
              <p>
                Published by <strong>Code Inputs</strong> • Complete Guide
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* BLOG CONTENT */}
      <section className="blog-wrapper">
        <div className="container">
          <div className="row">

            {/* BLOG MAIN CONTENT */}
            <div className="col-lg-8">
              <div className="blog-card">

                <img src="/graphics/images/notepad++_plugins.png" alt="Notepad++ Plugins" />

                
                <p>
                  Notepad++ is a widely used text and source code editor for Windows, 
                  favored for its speed, simplicity, and versatility. While it comes packed with 
                  powerful features by default, what truly elevates the user experience is its vast library 
                  of plugins. These Notepad++ plugins can dramatically improve your workflow, whether 
                  you're a developer, writer, or analyst.
                </p>

                <p>
                In this article, we’ll highlight the top Notepad++ plugins that can help you work smarter and more efficiently.
                </p>

                <h2>NPP FTP</h2>
                <p>
                  NppFTP is essential for users who frequently work with remote files. It enables seamless 
                  FTP, FTPS, and SFTP connections within Notepad++, allowing you to access, edit, and save 
                  files on remote servers without leaving the editor.
                </p>

                <h3>Productivity benefits:</h3>
                <ol>
                  <li>Eliminates the need for an external FTP client.</li>
                  <li>Enables direct file transfers and updates from within Notepad++.</li>
                </ol>

                <h2>Compare Plugin</h2>

                <p>
                  Need to spot differences between two files quickly? The Compare Plugin displays files 
                  side-by-side and highlights changes, making it easy to track modifications.
                </p>

                <h3>Why it’s effective:</h3>
                <ol>
                  <li>Saves time during code reviews or version comparisons.</li>
                  <li>Clearly marks additions, deletions, and changes for quick analysis.</li>
                </ol>

                <h2>JSON Viewer</h2>
                <p>
                  If you regularly work with JSON, this plugin is a game-changer. JSON Viewer formats and displays 
                  JSON data in an easy-to-navigate tree structure.
                </p>

                <h3>Why it’s effective:</h3>
                <ol>
                  <li>Simplifies complex JSON structures.</li>
                  <li>Ideal for developers working with APIs or configuration files.</li>

                </ol>

                <h2>XML Tools</h2>
                <p>For those dealing with XML, the XML Tools plugin provides handy features like 
                formatting, tag matching, validation, and XPath support.</p>
                <h3>Why it’s valuable:</h3>
                <ol>
                  <li>Enhances readability of XML content.</li>
                  <li>Makes it easy to troubleshoot and modify XML documents.</li>

                </ol>

                <h2>Code Alignment</h2>
                <p>This plugin helps organize your code by aligning elements such as =, : and other characters. Code Alignment 
                improves the visual structure of code blocks, making them easier to understand.</p>

                <h3>Productivity perks:</h3>
                <ol>
                  <li>Improves code clarity and organization.</li>
                  <li>Supports alignment across various programming languages.</li>
                </ol>


                <h2>MultiClipboard</h2>
                <p>MultiClipboard enhances your clipboard by saving multiple copied items, letting you access them later. 
                It’s perfect for juggling code snippets or text fragments.</p>

                <h3>Why it helps:</h3>
                <ol>
                  <li>Avoids overwriting clipboard history.</li>
                  <li>Speeds up repetitive tasks with easy access to past clips.</li>
                </ol>

                <h2>AutoSave</h2>
                <p>Never worry about losing your work again. The AutoSave plugin automatically saves your files at set intervals, 
                reducing the risk of data loss.</p>

                <h3>Benefits include:</h3>
                <ol>
                  <li>Peace of mind during long coding sessions.</li>
                  <li>Prevents accidental loss from crashes or power failures.</li>
                </ol>


                <h2>MarkdownViewer++</h2>
                <p>Writing in Markdown? MarkdownViewer++ lets you preview your Markdown files live as you write, 
                directly within Notepad++.</p>

                <h3>Efficiency gains:</h3>
                <ol>
                  <li>Instantly view formatted content.</li>
                  <li>Perfect for developers and content creators writing documentation or blogs.</li>
                </ol>


                <h2>Snippets Plugin</h2>
                <p>The Snippets Plugin is ideal for storing reusable code blocks or text templates. You can insert frequently used snippets with a 
                single click or shortcut.</p>

                <h3>Why it boosts productivity:</h3>
                <ol>
                  <li>Reduces repetitive typing.</li>
                  <li>Helps maintain consistency in coding and writing.</li>
                </ol>

                <h2>Spell-Checker</h2>
                <p>Though Notepad++ is developer-focused, many use it for general writing. The Spell-Checker plugin adds real-time spelling correction, making it handy for writing readable documentation, 
                comments, and content.</p>

                <h3>Advantages:</h3>
                <ol>
                  <li>Quickly identifies typos.</li>
                  <li>Enhances writing quality without switching apps.</li>
                </ol>

                <h2>How to Install Notepad++ Plugins</h2>
                  <h3>Adding plugins is simple:</h3>
                  <ol>
                  <li>Launch Notepad++.</li>
                  <li>Navigate to Plugins > Plugins Admin.</li>
                  <li>Search for the plugin you want.</li>
                  <li>Check the box and click Install.</li>
                  </ol>

                  <p>Installation is automatic, and you’ll see the plugin appear in your menu shortly.</p>

                  <h2>Final Thoughts</h2>
                  <p>Notepad++ is a powerful editor on its own, but when extended with the right Notepad++ 
                  plugins, it becomes a true productivity powerhouse. Whether you’re managing code, writing 
                  documentation, or working with data, these plugins streamline your tasks, reduce errors, and 
                  enhance your overall efficiency.</p>

                  <p>Explore these plugins, mix and match based on your needs, and unlock the full potential 
                  of Notepad++. A more efficient workflow is just a few clicks away!</p>

              </div>
            </div>

            {/* SIDEBAR */}
            <div className="col-lg-4">
              <div className="blog-sidebar">

                <div className="sidebar-card">
                  <h4 className="sidebar-title">Other Blogs</h4>

                    {otherblogs.length === 0 ? (
                    <p className="text-muted">No blogs found</p>
                  ) : (
                    otherblogs.map((item, index) => (
                      <a
                        href={`/${item.route}`}
                        className="other-blog"
                        key={index}
                      >
                        <img
                          src={`/graphics/images/${item.image}`}
                          alt={item.title}
                        />
                        <div>
                          <h6>{item.title}</h6>
                          <span>
                            {Math.floor(Math.random() * 10) + 1} min read
                          </span>
                        </div>
                      </a>
                    ))
                  )}

                </div>

                <div className="sidebar-card text-center">
                  <h5 className="mb-2">Need Custom Software?</h5>
                  <p className="small text-muted mb-3">
                    Let’s build something amazing together.
                  </p>
                  <a href="/contact" className="btn btn-primary w-100">
                    Contact Us
                  </a>
                </div>

              </div>
            </div>

          </div>
        </div>
      </section>
    </>
  );
};

export default BlogDetails;
